import React from 'react';

export default function ViewFill()
{
  return (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104 99">
      <title>View</title>
      <path id="Fill-v2" d="M69,30.47a24,24,0,0,0-33.94,0l-19,19,19,19a24,24,0,0,0,33.94,0l19-19ZM52,66.56A17.06,17.06,0,1,1,69.06,49.5,17.06,17.06,0,0,1,52,66.56Zm0-28.12V49.5l-7.82-7.82A11.06,11.06,0,1,0,52,38.44Z" />
    </svg>
  )
}